import { lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ROUTES } from './router_model';
import SpinnerLoader from './../assets/loader/SpinnerLoader';
import HeaderView from './../screens/components/Header/View/HeaderView';
import AboutPageView from './../screens/pages/aboutpage/View/AboutPageView';
import ContactPageView from './../screens/pages/contactpage/View/ContactPageView';
import AltProductPortfolioPageView from './../screens/pages/altproductportfoliopage/View/AltProductPortfolioPageView';
import useAnalytics from "../helper/useanalytics";
import HomePageView from './../screens/pages/homepage/View/HomePageView'
import ProductEnquiryView from "./../screens/pages/productenquirypage/View/ProductEnquiryView";
import SpaceDomainView from "../screens/pages/domain_pages/space/View/SpaceDomainView";
import RedirectToPDF from "../helper/qr_helper/QrHelper";
import RailwayDomainView from "../screens/pages/domain_pages/railways/View/RailwayDomainView";
import IotDomainView from "../screens/pages/domain_pages/iot/View/IotDomainView";

const PrivacyPolicyView = lazy(() => import("./../screens/pages/privacypolicypage/View/PrivacyPolicyPageView"));
const WarrantyActivationPageView = lazy(() => import("./../screens/pages/warrantyactivationpage/View/WarrantyActivationPageView"));
const PageNotFound = lazy(() => import("./../assets/404page/pagenotfound"));
const ComingSoonPageView = lazy(() => import("../screens/pages/comingsoonpage/View/ComingSoonPageView"));
const NewFooterView = lazy(() => import("../screens/components/Footer/View/NewFooterView"));
const CareersPageView = lazy(() => import("./../screens/pages/careerspage/View/CareersPageView"));
const JobStoriesView = lazy(() => import("./../screens/pages/jobstories/View/JobStoriesView"));
const JobRoleView = lazy(() => import("./../screens/pages/jobstories/View/JobRoleView"));
const JobApplicationView = lazy(() => import("./../screens/pages/jobstories/View/JobApplication"));
const NewsAndEventsView = lazy(() => import("./../screens/pages/newsandevents/View/NewsAndEventsView"));
const LeadershipView = lazy(() => import("./../screens/pages/leadershippage/View/LeadershipView"));

export const LayoutWrapper = () => {

  const location = useLocation();

  useAnalytics();

  const pathExists = Object.values(ROUTES).some(route => {
    if (route.includes('*')) return false;

    if (route.includes(':')) {
      const base = route.split('/:')[0];
      return location.pathname.startsWith(base);
    }

    return location.pathname === route;
  });

  return (

    <Suspense fallback={<SpinnerLoader />}>
      {(location.pathname !== ROUTES.CONTACTPAGE &&
        location.pathname !== ROUTES.CUSTOMERCARE &&
        location.pathname !== ROUTES.JOBSTORIESPAGE &&
        location.pathname !== ROUTES.JOBROLESPAGE) && (
          <HeaderView />

        )}

      <Routes>
        <Route path={ROUTES.HOMEPAGE} element={<HomePageView />} />
        <Route path={ROUTES.ABOUTPAGE} element={<AboutPageView />} />
        <Route path={ROUTES.CONTACTPAGE} element={<ContactPageView />} />
        <Route path={ROUTES.CUSTOMERCARE} element={<ContactPageView />} />
        <Route path={ROUTES.WARRANTYACTIVATION} element={<WarrantyActivationPageView />} />
        <Route path={ROUTES.PRODUCTPORTFOLIOPAGE} element={<AltProductPortfolioPageView />} />
        <Route path={ROUTES.PRIVACYPOLICY} element={<PrivacyPolicyView />} />
        <Route path={ROUTES.PRODUCTENQUIRY} element={<ProductEnquiryView />} />
        <Route path={ROUTES.SPACEDOMAINPAGE} element={<SpaceDomainView />} />
        <Route path={ROUTES.RAILWAYDOMAINPAGE} element={<RailwayDomainView />} />
        <Route path={ROUTES.IOTDOMAINPAGE} element={<IotDomainView />} />
        <Route path={ROUTES.NOTFOUNDPAGE} element={<PageNotFound />} />
        <Route path={ROUTES.COMINGSOON} element={<ComingSoonPageView />} />
        <Route path={ROUTES.UHFBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.IN_OFES_V2Brochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.IN_SRFX_20DBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.EmbeddedPCBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.FireandSafetyBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.CoachesHealthMonitoringSystemBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.MultiProductWebAppBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.KavachHealthMonitoringBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.CentralhealthMonitoringSystemBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.IOTBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.V3000Brochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.Bothv3000andv8000withsensiconnectBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.RugEdgeR8000Brochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.RugEdgeV3000Brochure} element={<RedirectToPDF />} />

        <Route path={ROUTES.GNSSModuleBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.EdgeLinkSRF100Brochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.IndustrialRuggedL2ManagedEthernetSwitchBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.SensiConnect1612ProBrochure} element={<RedirectToPDF />} />
        <Route path={ROUTES.AxleScaleProBrochure} element={<HomePageView />} />


        {/* <Route path={ROUTES.ALT_PRODUCT_PORTFOLIO} element={<AltProductPortfolioPageView />} /> */}
        {/* <Route path={ROUTES.PRODUCTPAGE} element={<ProductPageView />} /> */}
        <Route path={ROUTES.CAREERSPAGE} element={<CareersPageView />} />
        <Route path={ROUTES.JOBSTORIESPAGE} element={<JobStoriesView />} />
        <Route path={ROUTES.JOBROLESPAGE} element={<JobRoleView />} />
        <Route path={ROUTES.JOBAPPLICATION} element={<JobApplicationView />} />
        <Route path={ROUTES.NEWSEVENTSPAGE} element={<NewsAndEventsView />} />
        <Route path={ROUTES.LEADERSHIPPAGE} element={<LeadershipView />} />
      </Routes>


      {pathExists && <NewFooterView />}
    </Suspense>

  );
};
